import { DEFAULT_FORM_DATA } from "./lib/constants";

const initialState = {
    ...DEFAULT_FORM_DATA,
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_FORM_DATA":
            return {
                ...action.formData,
                barcodeType: action.formData.barcodeType || {},
            };
        case "RESET_FORM_DATA":
            return {
                ...DEFAULT_FORM_DATA,
                binTrackingNumber: action.binTrackingNumber || "",
                hasDigitalContent: action.hasDigitalContent,
                hasPremiumEditing: action.hasPremiumEditing,
                imagesNeedClientApproval: action.imagesNeedClientApproval,
                isFoodService: action.isFoodService,
                sendToGdsn: action.sendToGdsn,
            };
        case "UPDATE_FORM_DATA":
            return {
                ...state,
                [action.name]: action.value,
            };
        case "UPDATE_MANY_FORM_DATA":
            return {
                ...state,
                ...action.formChanges,
            };
        default:
            return state;
    }
};

export { reducer, initialState };
